import React, { useEffect, useMemo } from 'react';

export type DeviceFingerprint = {
	height: string;
	width: string;
	platform?: string;
	language: string;
};

export function useFingerprint(): DeviceFingerprint {
	const fingerprint = useMemo(
		() => ({
			height: window?.screen?.height.toString(),
			width: window?.screen?.width.toString(),
			platform: window.navigator.platform,
			language: window.navigator.language,
		}),
		[],
	);
	return fingerprint;
}
